import { getS, setS } from "./state";

/* ===== GET VALUE by path ===== */
export const getV = (path) => {
  const s = getS();
  if (!path) return "";
  const parts = path.split(".");
  // filter.* => s.filters
  if (parts[0] === "filter") {
    const key = parts.slice(1).join(".");
    return s.filters?.[key] ?? "";
  }
  return parts.reduce((obj, key) => obj?.[key], s);
};

/* ===== SET VALUE by path ===== */
export const setV = (path, value) => {
  const s = getS();
  if (!path) return;
  const parts = path.split(".");

  if (parts[0] === "filter") {
    const key = parts.slice(1).join(".");
    setS({ filters: { ...(s.filters || {}), [key]: value } });
    return;
  }

  const keys = [...parts];
  const last = keys.pop();
  let obj = { ...s };
  let cur = obj;
  keys.forEach((k) => { cur[k] = { ...(cur[k] || {}) }; cur = cur[k]; });
  cur[last] = value;
  setS(obj);
};
